export default {
    FETCH_NEWEST_NOTIFICATIONS(state, data) {

        state.notifications.new = [];
        state.notifications.counter = data.unreadCounter;
        
        data.notifications.forEach(notification => {
            state.notifications.new.push(notification);
        });
        
        if(data.unreadCounter > 3)
            state.notifications.new.splice(-1,1);
    },
    WIDGET(state, data) {
        // Classic appointment widget
        state.widget.appointment = data.appointment.appointment; 
        state.widget.specialist = data.appointment.specialist; 
        
        // Anytime meeting
        if(data.anytime) {
            state.anytimeWidget.meeting = data.anytime.meeting;
            state.anytimeWidget.user = data.anytime.user;
            state.anytimeWidget.otherUser = data.anytime.other_user;
        }
    },

    BILLING_DETAILS_MODAL(state, data){
        state.billingDetailsModal.active = data;
    }
}
